import Vue from "vue";

import Highcharts from "highcharts";
import Stock from "highcharts/modules/stock";
import Exporting from "highcharts/modules/exporting";
import Indicators from "highcharts/indicators/indicators";
import HighchartsVue from "highcharts-vue";

import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import awsconfig from "./aws-exports";

import toast from "./mixins/toast";

import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles
Vue.component("PrismEditor", PrismEditor);

const aws = {
  ...awsconfig,
  Auth: {
    identityPoolId: awsconfig.aws_cognito_identity_pool_id,
    region: awsconfig.aws_cognito_region,
    userPoolId: awsconfig.aws_user_pools_id,
    userPoolWebClientId: awsconfig.aws_user_pools_web_client_id
  },
  API: {
    endpoints: [
      {
        name: "prod-slippy",
        endpoint:
          "https://jgwq1w9m5h.execute-api.ap-southeast-2.amazonaws.com/prod"
      }
    ]
  }
};
Amplify.configure(aws);

Vue.config.productionTip = false;

Stock(Highcharts);
Exporting(Highcharts);
Indicators(Highcharts);
Vue.use(HighchartsVue);

Vue.use(AmplifyPlugin, AmplifyModules);
Vue.mixin(toast);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
